import { useState, useCallback } from 'react';

const visibleRows = {
    min: 0,
    max: 20,
};
const useVisibleRows = ({ index, itemsCount }) => {
    const isVisible = index >= visibleRows.min && index <= visibleRows.max;
    const [render, setRender] = useState(isVisible);
    const updateVisibleRows = useCallback(() => {
        setTimeout(() => {
            if (index < visibleRows.min) {
                visibleRows.min = index;
                visibleRows.max = index + itemsCount + 10;
            }
            if (index > visibleRows.max) {
                visibleRows.min = index - itemsCount - 10;
                visibleRows.max = index;
            }
            setRender(true);
        }, 100);
    }, [index, itemsCount]);
    if (!isVisible) {
        updateVisibleRows();
    }
    return {
        render,
    };
};

export { useVisibleRows };
//# sourceMappingURL=useVisibleRows.js.map
